// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../GeneratePriceModal/GeneratePriceModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-details-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.payment-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #3A445D;
}

.payment-amount {
    font-weight: 700;
    font-size: 18px;
}

.payment-status-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #E6F7F0;
    color: #00875A;
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 500;
}

.payment-status-chip img {
    height: 16px;
}

.confirm-btn {
    background-color: #00875A;  
    color: white;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
}

.confirm-btn:hover {
    background-color: #00694a;
}

@media (max-width: 600px) {
  .payment-details-body { gap: 10px; }
  .confirm-btn { padding: 8px 16px; font-size: 14px; }
}`, "",{"version":3,"sources":["webpack://./src/compoonents/PaymentDetailsModal/PaymentDetailsModal.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,wBAAwB,SAAS,EAAE;EACnC,eAAe,iBAAiB,EAAE,eAAe,EAAE;AACrD","sourcesContent":["@import '../GeneratePriceModal/GeneratePriceModal.css';\n\n.payment-details-body {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.payment-info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    color: #3A445D;\n}\n\n.payment-amount {\n    font-weight: 700;\n    font-size: 18px;\n}\n\n.payment-status-chip {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #E6F7F0;\n    color: #00875A;\n    padding: 6px 12px;\n    border-radius: 16px;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.payment-status-chip img {\n    height: 16px;\n}\n\n.confirm-btn {\n    background-color: #00875A;  \n    color: white;\n    border: none;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.confirm-btn:hover {\n    background-color: #00694a;\n}\n\n@media (max-width: 600px) {\n  .payment-details-body { gap: 10px; }\n  .confirm-btn { padding: 8px 16px; font-size: 14px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
